let toastInstance = null

export default {
  show (message, duration = 2000) {
    // 如果已经有toast在显示，先清除
    if (toastInstance) {
      document.body.removeChild(toastInstance)
      toastInstance = null
    }

    // 创建toast元素
    const toast = document.createElement('div')
    toast.className = 'custom-toast'
    toast.innerText = message

    // 添加样式
    const style = document.createElement('style')
    style.textContent = `
      .custom-toast {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 10px 20px;
        border-radius: 4px;
        font-size: 14px;
        max-width: 80%;
        text-align: center;
        z-index: 9999;
        animation: fadeIn 0.3s ease;
      }
      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translate(-50%, -40%);
        }
        to {
          opacity: 1;
          transform: translate(-50%, -50%);
        }
      }
    `
    document.head.appendChild(style)

    // 将toast添加到页面
    document.body.appendChild(toast)
    toastInstance = toast

    // 定时移除
    setTimeout(() => {
      if (toastInstance) {
        document.body.removeChild(toastInstance)
        toastInstance = null
      }
    }, duration)
  },

  success (message, duration) {
    this.show(message, duration)
  },

  error (message, duration) {
    this.show(message, duration)
  },

  loading (message = '加载中...', duration) {
    this.show(message, duration)
  }
}
